import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessagesState, Message } from "../../types";

const initialState: MessagesState = {
  messages: [],
  notifications: [],
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setMessages: (state, action: PayloadAction<Message[]>) => {
      state.messages = action.payload;
    },
    setNotifications: (state, action: PayloadAction<Message[]>) => {
      state.notifications = action.payload;
    },
  },
});

export const { setMessages, setNotifications } = messagesSlice.actions;
export default messagesSlice.reducer;
